import React from 'react';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { UseLocationScope } from '../AppLocation';
import { useResolve } from '../Container';
import { AccountHeaderBlock } from '../account/AccountHeaderBlock';
import { AccountPage } from '../account/AccountPage';
import { PageLoader } from '../account/PageLoader';
import { PlanStateHeaderBlock } from '../account/PlanStateHeaderBlock';
import { Page } from '../common/Page';
import { usePermissionCheck } from '../common/PermissionElements';
import { UseReturnLocation } from '../common/ReturnLocation';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { InvokeSetupPopupIfApplicable } from '../onboarding/SetupPopup';
import { boardBuild, boardCreateAndOpen } from '../workspace/BoardCommands';
import { QuickMenuStrip } from '../workspace/QuickMenuStrip';
import { Colors } from './../../ui';
import { AllBoardsMenu } from './AllBoardsMenu';
import { AllBoardsScope } from './AllBoardsScope';
import { AllBoardsView } from './AllBoardsView';
import { Scroller } from './Scroller';

const AllBoardsMenuStrip = () => {

    const dispatch = useResolve(CommandDispatcher);
    const canEdit = usePermissionCheck('da:write', 'wo:write');

    const onBlankBoard = async () => void (await dispatch(boardCreateAndOpen, ['BLANK']));
    const onUseTemplate = async () => void (await dispatch(boardBuild));

    return <QuickMenuStrip>
        <QuickMenuStrip.Button
            data-tour="ab-blank"
            label="Blank Board"
            icon="deqo://icons/dash/add-board"
            color={Colors.primaryLight}
            disabled={!canEdit}
            onClick={onBlankBoard}
        />
        <QuickMenuStrip.Button
            data-tour="ab-template"
            label="Use Template"
            icon="deqo://icons/dash/add-template"
            color={Colors.primaryLight}
            disabled={!canEdit}
            onClick={onUseTemplate}
        />
    </QuickMenuStrip>;
};

export const AllBoardsPage = () =>
    <AccountPage>
        <AllBoardsScope loader={PageLoader}>
            <UseReturnLocation href="/boards" />
            <UseLocationScope name="boards" value="boards" label="All Boards" />
            <Page.Header>
                <AllBoardsMenu />
                <Page.HeaderPush>
                    <PlanStateHeaderBlock />
                    <AccountHeaderBlock />
                </Page.HeaderPush>
            </Page.Header>
            <Flexer relative grow flex="column" >
                {/* <Page.Split> */}
                <Flexer inset flex>
                    <Scroller>
                        <Flexer grow flex="column" style={{ background: Colors.hover, minHeight: '100%' }}>
                            <AllBoardsMenuStrip />
                            <Page.Content>
                                <AllBoardsView />
                            </Page.Content>
                        </Flexer>
                    </Scroller>
                </Flexer>
                {/* <Page.Aside>
                        <SidebarPanelLayout>
                            <AllBoardsUserSidebarPanel />
                        </SidebarPanelLayout>
                    </Page.Aside> */}
                {/* </Page.Split> */}
            </Flexer>
            {/* <InvokeWelcomePopupIfApplicable /> */}
            <InvokeSetupPopupIfApplicable />
            {/* <Position at="bottomRight">
                <XmasTree />
            </Position> */}
        </AllBoardsScope>
    </AccountPage>;
